import * as React from "react";
import CircularProgress, { CircularProgressProps } from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export const ProgressBar = ({
    fillColor = "success",
    bgColor,
    thickness = 3.6,
    fontSize = "16px",
    ...restProps
}: CircularProgressProps & {
    value: number;
    fillColor?: "primary" | "secondary" | "error" | "info" | "success" | "warning" | "inherit";
    bgColor?: string;
    themecolor?: "dark" | "light";
    thickness?: number;
    fontSize?: string;
}) => {
    return (
        <Box sx={{ position: "relative", display: "inline-flex" }}>
            {bgColor && (
                <CircularProgress
                    variant="determinate"
                    value={100}
                    thickness={thickness}
                    sx={{ color: bgColor }}
                    {...(restProps?.size && { size: restProps.size })}
                />
            )}
            <CircularProgress
                variant="determinate"
                color={fillColor}
                thickness={thickness}
                {...restProps}
                sx={bgColor ? { position: "absolute" } : {}}
            />
            <Box
                sx={{
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    position: "absolute",
                }}>
                <Typography
                    variant="caption"
                    component="div"
                    sx={{
                        fontSize: fontSize,
                        fontWeight: "700",
                        color: restProps?.themecolor === "light" ? "#343841" : "#fff",
                    }}>{`${Math.round(restProps.value)}%`}</Typography>
            </Box>
        </Box>
    );
};
